import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import {Inject, Injectable} from '@angular/core'
import { catchError, Observable, throwError } from 'rxjs'

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(@Inject('BASE_API_URL') private baseUrl: string) {
  }

  //eslint-disable-next-line
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      url: `${this.baseUrl}/${request.url}`,
    })

    return next
      .handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleErrorRes(error))
      )
  }

  private handleErrorRes(error: HttpErrorResponse): Observable<never> {
    return throwError(() => error)
  }
}
